var React = require('react');

function CheckmarkBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m20.2505 9.12021c.5475.43295.6404 1.22779.2074 1.77529l-7.3803 9.3334c-.2289.2894-.5728.4644-.9416.4789-.3687.0146-.7254-.1328-.9763-.4033l-3.99718-4.3087c-.47474-.5117-.44474-1.3114.06699-1.7861s1.31142-.4448 1.78615.067l2.99404 3.2274 6.4655-8.17644c.4329-.54753 1.2278-.64041 1.7753-.20745z","fill":"#38355a","fillRule":"evenodd"}));
}

CheckmarkBlack.defaultProps = {"fill":"none","height":"28","viewBox":"0 0 28 28","width":"28"};

module.exports = CheckmarkBlack;

CheckmarkBlack.default = CheckmarkBlack;
